export default "__VITE_ASSET__1249a899__"